import { lazy } from "react";

export const HlsPlayer = lazy(() => import("./HlsPlayer"));
